module.exports = __webpack_public_path__ + "static/funnels6-d6799887364a97c623bc378ccefad4ae.png";